module.exports = __webpack_public_path__ + "img/rating.b18e2a69.png";